import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]

import 'gitart-vue-dialog/dist/style.css'
import ConfirmationModal from '@/components/Common/ConfirmationModal.vue'
import { ref } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteIcon',
  props: {
    showFlash: { type: Function },
    deleteAction: { type: Function },
    isDeleteAuthority: { type: Boolean },
    tooltipMessage: {}
  },
  setup(__props: any) {

const props = __props;

const dialogState = ref(false);
const loading = ref(false);

function closeModal() {
  dialogState.value = false
}

async function handleDelete() {
  loading.value = true
  await props.deleteAction()
  loading.value = false
  dialogState.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationModal, {
      modelValue: dialogState.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogState).value = $event)),
      title: _unref(i18n).global.t('common.confirmationModal.title'),
      note: _unref(i18n).global.t('common.confirmationModal.confirmDelete'),
      confirmBtnName: _unref(i18n).global.t('common.deleteBtn'),
      confirmBtnClass: "bg-danger text-white",
      loading: loading.value,
      onConfirm: handleDelete,
      onCancel: closeModal
    }, null, 8, ["modelValue", "title", "note", "confirmBtnName", "loading"]),
    (props.isDeleteAuthority)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogState.value = true)),
          class: "material-symbols-outlined"
        }, " delete "))
      : (_openBlock(), _createBlock(_component_v_tooltip, {
          key: 1,
          text: props.tooltipMessage
        }, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("button", _mergeProps({ class: "material-symbols-outlined" }, props, {
              disabled: !props.isDeleteAuthority,
              style: !props.isDeleteAuthority ? 'opacity: 0.5' : ''
            }), " delete ", 16, _hoisted_1)
          ]),
          _: 1
        }, 8, ["text"]))
  ], 64))
}
}

})